import axios, {AxiosInstance} from 'axios'
import MyAxiosInstanceFlow from './axiosInstanceFLow'

export class FlowApi {
    private flowApi: AxiosInstance
    constructor() {
        this.flowApi = MyAxiosInstanceFlow
    }

    async getFlow(): Promise<any> {
        try {
            const res = await this.flowApi.get('/document-flows')
            return res.data
        } catch (error) {
            console.error('Erro ao obter fluxo de documentos:', error)
            throw error
        }
    }

    async getFlowById(flow_id: string): Promise<any> {
        try {
            const res = await this.flowApi.get(`/document-flows/${flow_id}`)
            return res.data
        } catch (error) {
            console.error('Erro ao obter fluxo de documentos por ID:', error)
            throw error
        }
    }

    async createFlow(flowData: any): Promise<any> {
        try {
            const res = await this.flowApi.post('/document-flows', flowData)
            return res.data
        } catch (error) {
            console.error('Erro ao criar fluxo de documentos:', error)
            throw error
        }
    }

    async updateFlow(flowData: any): Promise<any> {
        try {
            const res = await this.flowApi.put(`/document-flows`, flowData)
            return res.data
        } catch (error) {
            console.error('Erro ao atualizar fluxo de documentos:', error)
            throw error
        }
    }

    //Rotas novas do back

    async updateDocumentParameters(flow_id: string, documentParameters: any): Promise<any> {
        try {
            const res = await this.flowApi.put(`/document-flows/${flow_id}/document_parameters`, documentParameters)
            return res.data
        } catch (error) {
            console.error('Erro ao atualizar document parameters:', error)
            throw error
        }
    }

    async getQuestionPreSignedUrl(data: {
    filename: string;
    question_uuid: string;
    project_uuid: string;
    }): Promise<{ url: string; tags: string }> {
        try {
            const res = await this.flowApi.post('/questions/pre-signed-url', data)
            return res.data
        } catch (error) {
            console.error('Erro ao obter URL pré-assinada para upload:', error)
            throw error
        }
    }

    async getUploadPreSignedUrl(
        data: {
            filename: 'draft.docx' | 'draft.txt' | 'template.docx';
            organization_id: string;
            document_type_id?: string | null;
            document_key?: string | null;
        },
        file: File
    ): Promise<string> {
        try {
            const res = await this.flowApi.post('/document-flows/pre-signed-url', data)
            const url: string = res.data

            await axios.put(url, file, {
                headers: {
                    'Content-Type': file.type,
                },
            })

            return  url 
        } catch (error) {
            console.error('Erro ao obter URL pré-assinada para upload:', error)
            throw error
        }
    }
}
